import * as React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

const Testimonial = ({testimonial, image, author}) => (
  <div className='testimonial p10'>
    <div className='grid-1-2 max-1400 ma m-block'>
      <div className='image m-hide'>
        <div className='max-75'>
          <div className='ratio-1-2 pos-rel bg-dark'>
            <GatsbyImage className='bg-image' image={image?.gatsbyImageData} alt="Testimonial Image" />
          </div>
        </div>
      </div>
      <div className='content'>
          <p className='m0 h3 medium text-light mb40'>{testimonial}</p>
          <div className='flex'>
            <p className='m0 text-light pt20 m-p0 with-dot'>{author}</p>
            <div className='max-75 w-100 mla m-show'>
              <div className='ratio-1-2 pos-rel bg-dark'>
                <GatsbyImage className='bg-image' image={image?.gatsbyImageData} alt="Testimonial Image" />
              </div>
            </div>
          </div>
      </div>
    </div>
  </div> 
) 
export default Testimonial
